<span matTooltip="Edit the order of columns on this table."
      matTooltipPosition="left"
      matTooltipClass="text-center"
      (click)="onClick()">
    <i class="far fa-bars"></i>
</span>
